<template>
  <div class="hint">
    <span class="hint-container">
      <font-awesome-icon class="icon" icon="exclamation-triangle" />
      <span class="hint-text">Please fill out all mandatory form fields.</span>
    </span>
  </div>
</template>

<script>
export default {
  name: "hint-view",
  props: {
    title: String,
  },
  components: {},
  computed: {},
  methods: {},
};
</script>

<style scoped>
.hint {
  width: 100%;
  height: 100%;
  display: flex;
  padding-top: 20%;
}

.icon {
  color: black;
}

.hint-container {
  display: flex;
  width: 100%;
  height: 50px;
  margin-top: 10px;
  align-items: center;
  border: 1px solid #ecb100;
  border-radius: 3px;
  padding-left: 15px;
  color: black;
}

.hint-text {
  padding-left: 5px;
}
</style>
